import { matchAll } from "../Utils/unsafe";
import { BaseScript } from "./BaseScript";
import Guid from "src/Utils/Guid";

export class RubyScript extends BaseScript {

	OpalScript: any = null;
	OpalCompiledScript: any = null;
	isCompileError: boolean = false;
	//может оптимизировать вместе с конвертацией скриптов
	depsRegex = /hostObject.GetValue\("(.[^"]+)"\)/g;
	convertRegex = /(hostObject.(?:GetValue|GetContextVariable|SetValue|GetColItemValue)\((?:(?:[^)(]+|\((?:[^)(]+|\([^)(]*\))*\))*)\))/g;
	replaceToEmptyKeyWords = [ "System::" ];

	getOpalScript = ( rubyScript: any ) => {
		let result = rubyScript;
		for (let i = 0; i < this.replaceToEmptyKeyWords.length; i++) {
			const keyWord = this.replaceToEmptyKeyWords[i];
			result = result.replaceAll(keyWord, '');
		}
		result = rubyScript.replaceAll("hostObject.FormObject", "Native(`hostObject.FormObject`)");
		result = result.replaceAll(this.convertRegex, "Native(`$1`)");
		result = result.replaceAll("to_clr_string", "to_s");
		result = result.replaceAll( "null", "nil" );
		result = result.trim();
		return result;
	};

	/**
	 * Парсим скрипт на наличие элементов 
	 */
	getDependentFields = () => {
		if (!this.Content) return [];
		const matches = matchAll(this.Content, this.depsRegex);
		if (matches) {
			return matches.map( item => item[1] );
		}
		return [];
	};

	/**
	 * Запустить скрипт в контексте hostObject
	 */
	override runScript = () => {
		// eslint-disable-next-line
		if (!this.Content || this.isCompileError) return null;
		window.hostObject = this.hostObject;
		window.Guid = Guid;
		let result = null;
		try {

			if (this.OpalCompiledScript === null) {
				try {
					this.OpalScript = this.getOpalScript(this.Content === null ? "" : this.Content);
					this.OpalCompiledScript = (window?.Opal as any).compile(this.OpalScript);
				} 
				catch ( error: any ) {
					console.groupCollapsed( "ruby" );
					console.error('ошибка компиляции ruby скрипта');
					console.log(this.Content);
					console.log(this.OpalScript);
					console.log(error.message);
					console.groupEnd();
					this.isCompileError = true;
					return null;
				}
			}

			//eval vs new function - в данном случае не влияют(значимо не влияют, разница маленькая) на производительность
			// eslint-disable-next-line
			result = eval(this.OpalCompiledScript);
			//если получили Null в руби
			if ( result === null || result.constructor.name === 'NilClass' || result.$$id === 4 )
				return null;

			//Нагло добавил метод $ToJsNative в модуль Opal(класс обёртка) и если он есть то зовём его
			if ( result.$ToJsNative !== undefined )
				result = result.$ToJsNative();
			else if (result.native !== undefined)
				result = result.native;

		} 
		catch ( e: any ) {
			console.groupCollapsed( "Ошибка выполнения ruby скрипта" );
			console.warn(e);
			console.log( "Orig - ", this.Content);
			console.log( "Converted - ", this.OpalScript);	
			console.groupEnd();
		}
		return result;
	};

};
